import React, { useEffect, useRef, useState } from "react";

const CustomInternetSpeedMeter = ({
  pingInterval = 1000,
  thresholdUnit = "megabyte",
  threshold = 8,
  imageUrl = "https://upload.wikimedia.org/wikipedia/commons/3/3f/Fronalpstock_big.jpg",
  downloadSize = 3100000,
  callbackFunctionOnNetworkDown = () => {},
  callbackFunctionOnNetworkTest = () => {},
  callbackFunctionOnError = () => {},
  txtMainHeading = "Opps...",
  txtSubHeading = "Disconnected from internet",
  outputType = "alert",
  customClassName = "",
  checked = true,
}) => {
  const [isNetworkDown, setIsNetworkDown] = useState(false);
  const timerRef = useRef();
  const cancelledRef = useRef(false);

  const showResults = (startTime, endTime) => {
    const duration = (endTime - startTime) / 1000;
    const bitsLoaded = downloadSize * 8;
    const speedBps = bitsLoaded / duration;
    const speedKbps = speedBps / 1024;
    const speedMbps = speedKbps / 1024;

    let speed = speedMbps;
    if (thresholdUnit === "byte") speed = speedBps;
    else if (thresholdUnit === "kilobyte") speed = speedKbps;

    if (speed < threshold) {
      setIsNetworkDown(true);
      callbackFunctionOnNetworkDown(speed);
    } else {
      setIsNetworkDown(false);
    }
    callbackFunctionOnNetworkTest(speed);
  };

  const measureConnectionSpeed = () => {
    if (cancelledRef.current) return;

    const startTime = new Date().getTime();
    const download = new Image();
    const cacheBuster = "?nnn=" + startTime;
    download.src = imageUrl + cacheBuster;

    download.onload = () => {
      if (cancelledRef.current) return;
      const endTime = new Date().getTime();
      showResults(startTime, endTime);
      timerRef.current = setTimeout(measureConnectionSpeed, pingInterval);
    };

    download.onerror = (err) => {
      if (cancelledRef.current) return;
      callbackFunctionOnError(err);
      setIsNetworkDown(true);
      callbackFunctionOnNetworkDown(0);
    };
  };

  const handleOffline = () => setIsNetworkDown(true);
  const handleOnline = () => setIsNetworkDown(false);

  useEffect(() => {
    cancelledRef.current = false;
    clearTimeout(timerRef.current);

    if (!checked) return;

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    measureConnectionSpeed();

    return () => {
      cancelledRef.current = true;
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      clearTimeout(timerRef.current);
    };
  }, [checked, pingInterval, thresholdUnit, threshold, imageUrl, downloadSize]);

  if (!checked) return null;

  if (isNetworkDown && outputType === "alert") {
    return (
      <div className={`custom-internet-alert ${customClassName}`}>
        <span style={{ fontWeight: "bold", color: "red" }}>{txtMainHeading}</span>
        <span>{txtSubHeading}</span>
      </div>
    );
  }

  return null;
};

export default CustomInternetSpeedMeter;
